import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { CommentableType } from '@utils/backend-api/comments';

import CommentsContent from './Content';

const queryClient = new QueryClient();

interface CommentsProps {
  commentableId: number;
  commentableType: CommentableType;
  commentsCount?: number;
}

const Comments = ({ commentableId, commentableType, commentsCount }: CommentsProps) => (
  <QueryClientProvider client={queryClient}>
    <CommentsContent
      commentableId={commentableId}
      commentableType={commentableType}
      commentsCount={commentsCount}
    />
  </QueryClientProvider>
);

export default Comments;
